import { ODataSearch } from 'src/app/_common/api/qs';
import { AppConstants } from '../../app.constants';

export class ODataBackAuthUsersSearch extends ODataSearch
{
    constructor(searchValue: string, incrSize: number = AppConstants.QSSearchTop)
    {
        super(searchValue, incrSize);

        if (this.searchValue !== null)
        {
            this.pushValue('$count', true);
            this.pushValue('$search', this.searchValue);
        }
    }
}
